import React, { useEffect, useState } from 'react';

interface ReactContextGuardProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Guard component that ensures React context is properly initialized
 * before rendering children. This prevents "Cannot read properties of null"
 * errors with React hooks.
 */
export const ReactContextGuard: React.FC<ReactContextGuardProps> = ({ 
  children, 
  fallback = null 
}) => {
  const [isReactReady, setIsReactReady] = useState(false);

  useEffect(() => {
    // Mark ready on next frame to allow any provider setup to complete
    const id = requestAnimationFrame(() => setIsReactReady(true));
    return () => cancelAnimationFrame(id);
  }, []);

  if (!isReactReady) {
    return <>{fallback}</>;
  }

  return <>{children}</>;

};